import { NOTION_PARENT_TYPE, NOTION_PROPERTIES, NOTION_TITLE, NOTION_BODY, NOTION_PROPERTIES_TITLE, NOTION_STATUS } from "@avenueops/shared-types";
import Link from "next/link";

interface Props {
  fullFieldName: string;
}

export function getNotionFieldDescription(fullFieldName: string): JSX.Element | null {
  switch (fullFieldName) {
    case NOTION_PARENT_TYPE:
      return (
        <span>
          The parent page or database where the new page is inserted. See the{" "}
          <strong>
            <Link href="https://developers.notion.com/reference/post-page">Notion API docs</Link>
          </strong>{" "}
          for more information.{" "}
        </span>
      );
    case NOTION_PROPERTIES:
      return (
        <span>
          The values of the page's properties. If the <code>parent</code> is a database, then the schema must match the parent database's properties. If the{" "}
          <code>parent</code> is a page, then the only valid object key is <code>title</code>.
        </span>
      );
    case NOTION_TITLE:
      return (
        <span>
          If present, overrides the signal title. Appears as an <strong>h1</strong> header in the body of the page
        </span>
      );
    case NOTION_BODY:
      return (
        <span>
          If present, overrides the signal body. Appears as a <strong>paragraph</strong> in the body of the page
        </span>
      );
    case NOTION_PROPERTIES_TITLE:
      return (
        <span>
          Controls the <code>title</code> that appears at the top of a page when a database row or page is opened
        </span>
      );
    case NOTION_STATUS:
      return <span>Defines the mapping between Avenue's signal status, and Notion's page status.</span>;

    default:
      return null;
  }
}
